//#region src/lexis.ts
/**
* Where a string, a comment or a quoted name begins, per dialect.
*
* - Free of imports, so anything that has to agree with the editor about a boundary can
*   read this without the language, the theme or the keyword lists.
* - `treatBitsAsBytes` on both: neither dialect has bit strings, and the grammar offers
*   no way to stop `b'`/`b"` opening one — only to choose which node it produces.
*/
const SQL_LEXIS = {
	snowflake: {
		identifierQuotes: "\"",
		slashComments: true,
		hashComments: false,
		backslashEscapes: true,
		doubleDollarQuotedStrings: true,
		caseInsensitiveIdentifiers: true,
		treatBitsAsBytes: true
	},
	bigquery: {
		identifierQuotes: "`",
		hashComments: true,
		slashComments: false,
		doubleQuotedStrings: true,
		backslashEscapes: true,
		caseInsensitiveIdentifiers: true,
		treatBitsAsBytes: true,
		specialVar: "@"
	}
};
//#endregion
export { SQL_LEXIS };

//# sourceMappingURL=lexis.js.map